// @flow
export const CLUSTER_WORKLOAD_DETAILS_FORM = 'CLUSTER_WORKLOAD_DETAILS_FORM';
export const SP_MAX_INPUT_VALUE_FOR_ANY_FIELD = 10000000;
